import angular from 'angular'

import {
    ovatBillRule
} from 'redevConfig'


const add = (ovatBillRule && ovatBillRule.add) || ''
const edit = (ovatBillRule && ovatBillRule.edit) || ''
const list = (ovatBillRule && ovatBillRule.list) || ''
const set = (ovatBillRule && ovatBillRule.set) || ''

const ovatBillRuleListCtrl = list ? require(`redevelopment/system/ovatBillRule/${list.controllerName}`) : require('./ovatBillRuleListCtrl')
const addOvatBillRuleCtrl = add ? require(`redevelopment/system/ovatBillRule/${add.controllerName}`) : require('./addOvatBillRuleCtrl')
const editOvatBillRuleCtrl = edit ? require(`redevelopment/system/ovatBillRule/${edit.controllerName}`) : require('./editOvatBillRuleCtrl')
const ovatBillRuleCtrl = set ? require(`redevelopment/system/ovatBillRule/${set.controllerName}`) : require('./ovatBillRuleCtrl')

const ovatBillRuleListCtrlPage = list ? require(`redevelopment/system/ovatBillRule/${list.templateName}`) : require('./view/ovatBillRuleListCtrl.html')
const addOvatBillRuleCtrlPage = add ? require(`redevelopment/system/ovatBillRule/${add.templateName}`) : require('./view/addOvatBillRuleCtrl.html')
const editOvatBillRuleCtrlPage = edit ? require(`redevelopment/system/ovatBillRule/${edit.templateName}`) : require('./view/editOvatBillRuleCtrl.html')
const ovatBillRuleCtrlPage = set ? require(`redevelopment/system/ovatBillRule/${set.templateName}`) : require('./view/ovatBillRuleCtrl.html')

export default angular
    .module('system.settingcenter.ovatBillRule', [])
    .config(['$stateProvider', function config($stateProvider) {
        $stateProvider
            .state('system.settingcenter.ovatBillRule', {
                abstract: true,
                url: '/ovatBillRule',
                template: '<div ui-view></div>',
                title: '拆合规则',
                default: 'system.settingcenter.ovatBillRule.list',
            })
            .state('system.settingcenter.ovatBillRule.set', {
                url: '/set/:ruleSchemaCode',
                template: ovatBillRuleCtrlPage,
                controller: 'ovatBillRuleCtrl',
                title: '设置',
            })
            .state('system.settingcenter.ovatBillRule.list', {
                url: '/list',
                template: ovatBillRuleListCtrlPage,
                controller: 'ovatBillRuleListCtrl',
            })
            .state('system.settingcenter.ovatBillRule.add', {
                url: '/add',
                template: addOvatBillRuleCtrlPage,
                controller: 'addOvatBillRuleCtrl',
                title: '新增',
            })
            .state('system.settingcenter.ovatBillRule.edit', {
                url: '/edit/:ruleSchemaCode',
                template: editOvatBillRuleCtrlPage,
                controller: 'editOvatBillRuleCtrl',
                title: '编辑',
            })
    }])
    .controller('ovatBillRuleCtrl', ovatBillRuleCtrl.default)
    .controller('ovatBillRuleListCtrl', ovatBillRuleListCtrl.default)
    .controller('addOvatBillRuleCtrl', addOvatBillRuleCtrl.default)
    .controller('editOvatBillRuleCtrl', editOvatBillRuleCtrl.default)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/ovatBillRule/index.js